import { lignes } from '../lines.js'
import { LigneButtonElement } from './line-button.js'

export class LinesListElement extends HTMLElement {
	constructor() {
		super()

		const shadow = this.attachShadow({ mode: 'open' })

		lignes.forEach((line, key) => {
			const button = new LigneButtonElement()
			button.setLine(key)
			shadow.appendChild(button)
		})
	}
}

customElements.define('lines-list', LinesListElement)
